import { BotInstance } from './Bot.instance'

export const botDirective = {
	mounted(element, { arg, value }) {
		if (arg !== 'event' || !value) return

		const event = BotInstance.events.setup({ element, ...value })

		if (event) {
			element.setAttribute('data-bot-event', event.id)
		}
	},
	unmounted(element) {
		const id = element.getAttribute('data-bot-event')

		if (id) {
			BotInstance.events.remove(id)
			element.removeAttribute('data-bot-event')
		}
	},
}
